import * as React from 'react';
import { connect } from 'react-redux';

import { navigate } from '~/router';

import Form from '../../components/auth/ForcePasswordChangeForm';
import { forcePasswordChange } from '../../actions/auth';
import { redirectToHome } from '../../helpers';


class ForcePasswordChangeForm extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);

    this.state = {};
  }

  componentDidMount() {
    const { username } = this.props;

    if (!username) {
      navigate('login');
    }

    // TODO: This is a small hack as unsuccessful login/reset password request resets current username
    this.setState({
      username,
    });
  }

  onSubmit(values) {
    const { dispatch } = this.props;
    const { username } = this.state;
    const { password, newPassword, acceptTerms } = values;

    return dispatch(forcePasswordChange(username, password, newPassword, acceptTerms))
      .then((data) => {
        const user = data.entities.users[data.result.user];
        const org = data.entities.organizations[user.organizationId];

        redirectToHome(user, org);
      });
  }

  render() {
    const { errorMessage } = this.props;
    const { username } = this.state;

    return (
      <Form
        userName={username}
        onSubmit={this.onSubmit}
        error={errorMessage}
        submitting={false}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.shared.auth.loading,
    errorMessage: state.shared.auth.errorMessage,
    username: state.shared.auth.username,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForcePasswordChangeForm);
